import React, { Component } from "react";
import { Navbar, Nav, NavItem, Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { t } from "i18next";
import logo from "../../assets/jl-logo.png";
import tbklogo from "../../assets/tbk-icon.png";
import PropTypes from "prop-types";
import store from "../../services/ReduxStore";

class Header extends Component {
  static propTypes = {
    user: PropTypes.object,
  };

  render() {
    const dashboardUrl = store.getState().app.data
      ? store.getState().app.data.dashboardUrl
      : null;

    return (
      <header>
        <Navbar inverse collapseOnSelect fluid>
          <Navbar.Header>
            <a
              className="navbar-brand"
              href="//jiffylubeontario.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={logo} alt="Jiffy Lube Ontario" />
            </a>
            {/* <a className="tbk-icon" href="//tbkcreative.com" target="_blank" rel="noopener noreferrer"><img src={tbklogo} alt="tbk Creative" /></a> */}
            <div className="navbar-spacer"></div>
            <Navbar.Toggle>
              <span className="sr-only">{t("Toggle Navigation")}</span>
              <i className="icon-menu" />
            </Navbar.Toggle>
          </Navbar.Header>
          {this.props.user && (
            <Navbar.Collapse>
              <Navbar.Form pullLeft>
                <LinkContainer to="/editor/new">
                  <Button bsStyle="primary" className="navbar-btn">
                    <i className="icon-add"></i> {t("New")}
                  </Button>
                </LinkContainer>
              </Navbar.Form>
              <Nav>
                <LinkContainer to="/" exact>
                  <NavItem>{t("Home")}</NavItem>
                </LinkContainer>
                <LinkContainer to="/library">
                  <NavItem>{t("Library")}</NavItem>
                </LinkContainer>
                <LinkContainer to="/manager">
                  <NavItem>{t("Manager")}</NavItem>
                </LinkContainer>
              </Nav>
              <Nav pullRight>
                {dashboardUrl && (
                  <NavItem href={dashboardUrl} target="_blank">
                    {t("Dashboard")}
                  </NavItem>
                )}
                <LinkContainer to="/logout">
                  <NavItem>{t("Logout")}</NavItem>
                </LinkContainer>
              </Nav>
            </Navbar.Collapse>
          )}
        </Navbar>
      </header>
    );
  }
}

export { Header };
